<template>


    <form class="loginform" @submit.prevent="onSubmit">

        <div class="textonly error" v-if="loginError">
            <p>Die von Ihnen eingegebenen Login-Daten stimmen mit keinem der bei uns registrierten Konten überein. Bitte beachten Sie stets bei Ihrem Benutzernamen sowie Ihrem Passwort die Groß- und Kleinschreibung.</p>
        </div>

        <div class="textonly error" v-if="keineZugangsdaten">
            <p>Um sich anzumelden müssen sie Ihren Benutzername und das zugehörige Passwort angeben.</p>
        </div>

        <div class="form-group">

            <div class="form-input border icon-user">
                <input class="form-control" v-model="benutzerName" id="Benutzername" name="Benutzername" type="text" placeholder="Ihr Benutzername" autocomplete="username">
            </div>

        </div>

        <div class="form-group">

            <div class="form-input border icon-password ">
                <input class="form-control" v-model="passwort" id="Passwort" name="Passwort" type="password" placeholder="Passwort" autocomplete="current-password">
            </div>

        </div>

        <button type="submit" class="button small" name="input-submit" id="input-submit">Einloggen</button>

        <div class="links">
            <a class="link arrow" :href="'/registrierung/?l=' + auftrag">Sie besitzen noch keine Zugangsdaten?</a>
            <a class="link arrow" href="/zugangsdatenvergessen">Sie haben Ihre Zugangsdaten vergessen?</a>
        </div>
    </form>
    <div class="editor-content" v-show="!bodyText">
        <p>wird geladen....</p>
    </div>
    
</template>

<script lang="ts">
    import { defineComponent } from "vue";
    import { extractAttrs } from "../../services/extract-attrs";
    import { getCurrentQueryParameters } from "../../services/get-current-query-parameters";
    import ApiService from "@/services/apiService";
import { getFormHashString } from "@/services/formSession";

    const LoginForm = defineComponent({
        name: "LoginForm",
        data() {
            return {
                bodyText: "",
                headerText: "",
                loginError: false,
                keineZugangsdaten: false,
                benutzerName: "",
                passwort: "",
                resolution: "",
                auftrag: "",
                sessionId: "",
                redirectUrl: ""
            }
        },
        props: {
            container: HTMLElement
        },
        async beforeMount() {
            this.resolution = screen.width + "x" + screen.height;

            var attrs = extractAttrs(this.container!);
            var session = getFormHashString(attrs["session"]);
            this.auftrag = attrs["auftrag"];
            this.redirectUrl = attrs["redirecturl"];
            this.loginError = getCurrentQueryParameters()["loginError"] === "true";
            var params = {
                form: "LoginForm",
                sessionId: session,
                auftrag: this.auftrag
            }

            const data = await ApiService.Instance.PostData("/umbraco/aliud/login/getmodel", params) as any;
            this.sessionId = getFormHashString(data["sessionId"]);

            this.bodyText = data["bodyText"];
            this.headerText = data["headerText"];
            this.auftrag = data["auftrag"];
        },
        methods: {
            async onSubmit(event: Event) {
                this.keineZugangsdaten=false;

                if (this.benutzerName.trim()==="" || this.benutzerName.trim()==="") {
                    this.keineZugangsdaten=true;
                    event.preventDefault();
                    return;
                }
            
                var vm = this;
                var parameters = {
                    username: this.benutzerName,
                    password: this.passwort,
                    sessionId: this.sessionId,
                    form: "LoginForm",
                    auftrag: this.auftrag,
                    resolution: this.resolution,
                    redirectUrl: this.redirectUrl
                }

                // Das ist die eigentliche Login-Validierung
                const response = await ApiService.Instance.PostData("/umbraco/aliud/login/postlogin", parameters) as any;
                vm.handleResponse(response);
            },
            handleResponse(response: any) {
                if (response.loginError) {
                    this.reloadWithParam("loginError", "true")
                }
                else {
                    window.location.href = response.loginReturn;
                }
            },
            reloadWithParam(key: any, value: any) {
                try {
                    // Create a URL object from the current location
                    const url = new URL(window.location.href);

                    // Set or update the query parameter
                    url.searchParams.set(key, value);

                    // Redirect to the updated URL (triggers reload)
                    window.location.href = url.toString();
                } catch (err) {
                    console.error("Error updating URL parameter:", err);
                }
            }
        },
    });
    export default LoginForm;
</script>